<template>
  <div class="container loanAudit" style="z-index:1">
    <div class="bankAuditDialog">
      <el-row>
        <el-col :span="24">
          <div class="bankAuditHeader">
            <div class="bankAuditHeaderName"></div>
            <div class="bankAuditHeaderClose" title="关闭" @click="closeContent">×</div>
          </div>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName">
        <el-tab-pane label="审核信息" name="first">
          <el-scrollbar :height="scrollHeight" :noresize="true">
            <el-form :rules="rules_loanAudit" ref="ruleForm" style="width:100%" :model="loanAudit">
              <el-row>
                <el-col :span="24">
                  <div class="bankAuditTitle">
                    <div class="bankAuditSplit"></div>
                    基本信息
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="3" v-if="flowInfo.PersonFlag===2">
                  <div class="bankAuditLB">企业名称：</div>
                </el-col>
                <el-col :span="5" v-if="flowInfo.PersonFlag===2">
                  <div class="bankAuditContent">
                    <el-input
                      disabled
                      v-model="loanApply.PersonCompanyText"
                      size="small"
                      placeholder="">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="3" v-if="flowInfo.PersonFlag===1">
                  <div class="bankAuditLB">姓名：</div>
                </el-col>
                <el-col :span="5" v-if="flowInfo.PersonFlag===1">
                  <div class="bankAuditContent">
                    <el-input
                      disabled
                      v-model="flowInfo.Name"
                      size="small"
                      placeholder="">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="3" v-if="flowInfo.PersonFlag===2">
                  <div class="bankAuditLB">法定代表人：</div>
                </el-col>
                <el-col :span="5" v-if="flowInfo.PersonFlag===2">
                  <div class="bankAuditContent">
                    <el-input
                      disabled
                      v-model="flowInfo.Name"
                      size="small"
                      placeholder="">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">联系方式：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-input
                      disabled
                      v-model="loanApply.Phone"
                      size="small"
                      placeholder="">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">区域：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <!-- <el-input
                        v-model="bankInfoObj.AreaName"
                        size="small"
                        placeholder="请输入区域">
                    </el-input> -->
                    <el-form-item prop="Area">
                      <el-select v-model="loanAudit.Area" size="small" placeholder="请选择">
                        <el-option :label="area.AreaName" :value="area.AreaName" :key="area.AreaName" v-for="area in areaList"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="3">
                                        <div class="bankAuditLB">主营业务：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select size="small" v-model="loanAudit.Business" @change="onFirstBusinessChooseConfirm" filterable  placeholder="请选择" style="width:250px;">
                                                <el-option
                                                        v-for="item in firstBusinessOption"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">二级分类：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select
                                            @change="changeSecond"
                                              v-model="loanAudit.ThirdBusiness"
                                               multiple
                                               clearable
                                             collapse-tags
                                              placeholder="请选择"
                                              style="width: 210px"
                                              >
                                          <el-option
                                          v-for="item in xmlist"
                                              :key="item"
                                          :label="item"
                                           :value="item"
                                          />
                                         </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3" v-if="businessShow">
                                        <div class="bankAuditLB">业务说明：</div>
                                    </el-col>
                                    <el-col :span="5" v-if="businessShow">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                v-model="loanAudit.BusinessDetail"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
              </el-row>
              <el-row>
                <el-col :span="3">
                  <div class="bankAuditLB">客户类型：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="CustomType">
                      <el-select v-model="loanAudit.CustomType" placeholder="请选择" size="small">
                        <el-option
                          v-for="item in khlx"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">客户性质：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="CustomProperty">
                      <el-select v-model="loanAudit.CustomProperty" placeholder="请选择" size="small">
                        <el-option
                          v-for="item in khxz"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">项目类别：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="ProTypeName">
                      <el-select v-model="loanAudit.ProTypeName" placeholder="请选择" size="small" @change="proTypeChange">
                        <el-option
                          v-for="item in proTypeList"
                          :key="item.ProTypeName"
                          :label="item.ProTypeName"
                          :value="item.ProTypeName">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="3">
                  <div class="bankAuditLB">项目风险比例(%)：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="RiskSharing">
                      <el-input
                        v-model="loanAudit.RiskSharing"
                        size="small"
                        placeholder="">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">贷款金额(万元)：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-input
                      disabled
                      v-model="loanApply.Money"
                      size="small"
                      placeholder="">
                    </el-input>
                  </div>
                </el-col>
                <!-- <el-col :span="3">
                    <div class="bankAuditLB">贷款合同号：</div>
                </el-col>
                <el-col :span="5">
                    <div class="bankAuditContent">
                        <el-input
                            v-model="loanAudit.LoanCode"
                            size="small"
                            placeholder="请输入贷款合同号">
                        </el-input>
                    </div>
                </el-col> -->
                <el-col :span="3">
                  <div class="bankAuditLB">贷款银行：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-input
                      disabled
                      v-model="bankInfoObj.BankSiteName"
                      size="small"
                      placeholder="">
                    </el-input>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <!-- <el-col :span="3">
                    <div class="bankAuditLB">还款状态：</div>
                </el-col>
                <el-col :span="5">
                    <div class="bankAuditContent">
                        <el-select v-model="loanAudit.ReturnMoneyStatus" placeholder="请选择" size="small">
                            <el-option
                            v-for="item in hkzt"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </el-col> -->
                <el-col :span="3">
                  <div class="bankAuditLB">担保期限(月)：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="LoanMonth">
                      <el-input
                        v-model="loanAudit.LoanMonth"
                        size="small"
                        onkeyup="value=value.replace(/[^0-9]/g,'')"
                        placeholder="请输入担保期限(月)"
                        @change="onDbqxChange">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- <el-col :span="3">
                    <div class="bankAuditLB">出具担保函时间：</div>
                </el-col>
                <el-col :span="5">
                    <div class="bankAuditContent">
                        <el-date-picker
                            v-model="loanAudit.GuaranteeLetterTime"
                            size="small"
                            type="date"
                            placeholder="选择出具担保函时间">
                        </el-date-picker>
                    </div>
                </el-col> -->
                <el-col :span="3">
                  <div class="bankAuditLB">到期时间：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="LoanEndTime">
                      <el-date-picker
                        v-model="loanAudit.LoanEndTime"
                        size="small"
                        type="date"
                        placeholder="选择到期时间：">
                      </el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">贷款合同号：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="LoanCode">
                      <el-input
                        v-model="loanAudit.LoanCode"
                        size="small"
                        placeholder="请输入贷款合同号">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="3">
                  <div class="bankAuditLB">担保费率(%)：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="GuaranteeRate">
                      <el-input
                        v-model="loanAudit.GuaranteeRate"
                        @change="onDBFLChange"
                        size="small"
                        placeholder="请选择项目类别">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">担保费(元)：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="LoanMoney">
                      <el-input
                        v-model="loanAudit.LoanMoney"
                        size="small"
                        placeholder="请选择项目类别、输入担保期限（月）">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">借款利率：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="LoanRate">
                      <el-input
                        v-model="loanAudit.LoanRate"
                        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                        size="small"
                        placeholder="请输入借款利率">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="3">
                  <div class="bankAuditLB">五级分类：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="Category">
                      <el-select v-model="loanAudit.Category" placeholder="请选择" size="small">
                        <el-option
                          v-for="item in wjfx"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">主调：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="FristInquirer">
                      <el-input
                        v-model="loanAudit.FristInquirer"
                        size="small"
                        placeholder="请输入主调">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">副调：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-form-item prop="SecondInquirer">
                      <el-input
                        v-model="loanAudit.SecondInquirer"
                        size="small"
                        placeholder="请输入副调">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- <el-col :span="3">
                    <div class="bankAuditLB">委托担保合同号：</div>
                </el-col>
                <el-col :span="5">
                    <div class="bankAuditContent">
                        <el-input
                            v-model="loanAudit.EntrustedGuarantee"
                            size="small"
                            placeholder="请输入委托担保合同号">
                        </el-input>
                    </div>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="3">
                  <div class="bankAuditLB">银行客户经理：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanAudit.AccountManager"
                      size="small"
                      placeholder="请输入银行客户经理">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">银行客户经理联系方式：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanAudit.AccountManagerPhone"
                      size="small"
                      placeholder="请输入银行客户经理联系方式">
                    </el-input>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="bankAuditTitle">
                    <div class="bankAuditSplit"></div>
                    经营情况
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="3">
                  <div class="bankAuditLB">资产总额（万元）：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanAudit.TotalAssets"
                      size="small"
                      placeholder="请输入资产总额（万元）">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="3">
                                        <div class="bankAuditLB">资产负债率（%）：</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                               @change="changeAssetCoverage"
                                                v-model="loanAudit.AssetCoverage"
                                                size="small"
                                                placeholder="请输入资产负债率">
                                            </el-input>
                                        </div>
                                    </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">上年营业收入（万元）：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanAudit.LastYearIncomeAudit"
                      size="small"
                      placeholder="请输入上年营业收入（万元）">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">上年利润（万元）：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanAudit.LastYearProfitAudit"
                      size="small"
                      placeholder="请输入上年利润（万元）">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">上年税收（万元）：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanAudit.LastYearTaxAudit"
                      size="small"
                      placeholder="请输入上年税收（万元）">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="bankAuditLB">从业人数：</div>
                </el-col>
                <el-col :span="5">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanAudit.PeopleCountAudit"
                      size="small"
                      placeholder="请输入从业人数">
                    </el-input>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="bankAuditTitle" style="position: relative;">
                    <div class="bankAuditSplit"></div>
                    反担保方式
                    <div style="left: 0px;top: 0px;position: absolute;width: 100%;display: flex;justify-content: center;align-items: center;height: 40px">
                      <el-radio-group v-model="loanAudit.GuaranteeType" style="margin:0px auto;" @change="loanTypeChange">
                        <el-radio :label="1">信用</el-radio>
                        <el-radio :label="2">保证</el-radio>
                        <el-radio :label="3">组合</el-radio>
                        <el-radio :label="4">抵押</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-dialog
                title="添加担保内容"
                v-model="dialogVisible2"
                width="30%"
                :before-close="handleClose">
                <el-form label-width="100px">
                  <el-form-item label="选择添加类型">
                    <el-select v-model="dyType" placeholder="请选择" size="small">
                      <el-option
                        v-for="item in dyTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <template #footer>
                                    <span class="dialog-footer">
                                        <el-button size="small" @click="dialogVisible2 = false">取 消</el-button>
                                        <el-button size="small" type="primary" @click="onAddItemChange">确 定</el-button>
                                    </span>
                </template>
              </el-dialog>
              <template v-if="loanAudit.GuaranteeType===1">
                <el-row>
                  <el-col :span="2">
                    <div class="bankAuditLB">暂无信息</div>
                  </el-col>
                </el-row>
              </template>
              <template v-if="loanAudit.GuaranteeType===2">
                <template v-if="loanMortgage&&loanMortgage.length>0">
                  <template v-for="(item,index) in loanMortgage" :key="item.Id">
                    <template v-if="item.Type === -1" >
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">保证人姓名：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.Guarantor"
                              size="small"
                              placeholder="请输入保证人姓名">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">身份证号码：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.GuarantorID"
                              size="small"
                              placeholder="请输入身份证号码">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                  </template>
                </template>
                <el-row>
                  <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="showInput">+ 新增</el-button>
                </el-row>
              </template>
              <template v-if="loanAudit.GuaranteeType===3">
                <template v-if="loanMortgage&&loanMortgage.length>0">
                  <template  v-for="(item,index) in loanMortgage" :key="item.Id">
                    <template v-if="item.Type === -1" >
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">保证人姓名：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.Guarantor"
                              size="small"
                              placeholder="请输入保证人姓名">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">身份证号码：</div>
                        </el-col>
                        <el-col :span="5">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.GuarantorID"
                              size="small"
                              placeholder="请输入身份证号码">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-if="item.Type === 0" >
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">不动产：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.BdcName"
                              size="small"
                              placeholder="请输入所有权人">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.BdcQzh"
                              size="small"
                              placeholder="请输入权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">面积：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.BdcArea"
                              size="small"
                              placeholder="请输入面积">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.BdcMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.BdcDyqzh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-else-if="item.Type === 1">
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">设备：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SbName"
                              size="small"
                              placeholder="请输入所有权人">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">数量：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SbCount"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入数量">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">型号：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SbType"
                              size="small"
                              placeholder="请输入设备名及型号">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SbMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SbDyqzh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-else-if="item.Type === 2">
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">水域滩涂：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SytName"
                              size="small"
                              placeholder="请输入所有权人">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SytQzh"
                              size="small"
                              placeholder="请输入权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">面积：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SytArea"
                              size="small"
                              placeholder="请输入面积">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SytMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SytDyqzh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-else-if="item.Type === 3">
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">农村承包土地：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.NccbtdName"
                              size="small"
                              placeholder="请输入所有权人">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.NccbtdQzh"
                              size="small"
                              placeholder="请输入权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">面积：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.NccbtdArea"
                              size="small"
                              placeholder="请输入面积">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.NccbtdMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.NccbtdDyqzh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-else-if="item.Type === 4">
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">股权：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.GqName"
                              size="small"
                              placeholder="请输入所有权人">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">数量：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.GqCount"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入数量">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.GqMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.GqDyzqh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-else-if="item.Type === 5">
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">其他：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.OtherBfwName"
                              size="small"
                              placeholder="请输入其他">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">规格：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.OtherBfwGg"
                              size="small"
                              placeholder="请输入规格">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.OtherBfwMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.OtherBfwDyqzh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                  </template>
                </template>
                <el-row>
                  <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="showInput">+ 新增</el-button>
                </el-row>
              </template>
              <template v-if="loanAudit.GuaranteeType===4">
                <template v-if="loanMortgage&&loanMortgage.length>0">
                  <template  v-for="(item,index) in loanMortgage" :key="item.Id">
                    <template v-if="item.Type === 0" >
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">不动产：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.BdcName"
                              size="small"
                              placeholder="请输入所有权人">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.BdcQzh"
                              size="small"
                              placeholder="请输入权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">面积：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.BdcArea"
                              size="small"
                              placeholder="请输入面积">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.BdcMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.BdcDyqzh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-else-if="item.Type === 1">
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">设备：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SbName"
                              size="small"
                              placeholder="请输入所有权人">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">数量：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SbCount"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入数量">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">型号：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SbType"
                              size="small"
                              placeholder="请输入设备名及型号">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SbMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SbDyqzh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-else-if="item.Type === 2">
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">水域滩涂：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SytName"
                              size="small"
                              placeholder="请输入所有权人">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SytQzh"
                              size="small"
                              placeholder="请输入权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">面积：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SytArea"
                              size="small"
                              placeholder="请输入面积">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SytMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.SytDyqzh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-else-if="item.Type === 3">
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">农村承包土地：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.NccbtdName"
                              size="small"
                              placeholder="请输入所有权人">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.NccbtdQzh"
                              size="small"
                              placeholder="请输入权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">面积：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.NccbtdArea"
                              size="small"
                              placeholder="请输入面积">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.NccbtdMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.NccbtdDyqzh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-else-if="item.Type === 4">
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">股权：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.GqName"
                              size="small"
                              placeholder="请输入所有权人">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">数量：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.GqCount"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入数量">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.GqMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.GqDyzqh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                    <template v-else-if="item.Type === 5">
                      <el-row>
                        <el-col :span="2">
                          <div class="bankAuditLB">其他：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.OtherBfwName"
                              size="small"
                              placeholder="请输入其他">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">规格：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.OtherBfwGg"
                              size="small"
                              placeholder="请输入规格">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">价值(万元)：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.OtherBfwMoney"
                              size="small"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              onblur="value.slice(-1) == '.'?value = value.slice(0,value.length - 1):''"
                              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                              placeholder="请输入价值">
                            </el-input>
                          </div>
                        </el-col>
                        <el-col :span="2">
                          <div class="bankAuditLB">抵押权证号：</div>
                        </el-col>
                        <el-col :span="3">
                          <div class="bankAuditContent">
                            <el-input
                              v-model="item.OtherBfwDyqzh"
                              size="small"
                              placeholder="请输入抵押权证号">
                            </el-input>
                          </div>
                        </el-col>
                        <span class="removeTypeItem" @click="onRemoveTypeChange(index)">×</span>
                      </el-row>
                    </template>
                  </template>
                </template>
                <el-row>
                  <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="showInput">+ 新增</el-button>
                </el-row>
              </template>
              <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        信用评分
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">征信记录：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="xyzk_value1"> 
                                            <el-select v-model="loanAudit.xyzk_value1" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">征信查询:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="xyzk_value2"> 
                                            <el-select v-model="loanAudit.xyzk_value2" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">诉讼及执行情况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="xyzk_value3"> 
                                            <el-select v-model="loanAudit.xyzk_value3" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list3"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">借款人稳定性：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="xyzk_value4"> 
                                            <el-select v-model="loanAudit.xyzk_value4" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list4"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">企业经营情况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="xyzk_value5"> 
                                            <el-select v-model="loanAudit.xyzk_value5" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list5"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">财务状况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="hknl_value1"> 
                                            <el-select disabled v-model="loanAudit.hknl_value1" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in hknl_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">收入及现金流:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="hknl_value2"> 
                                            <el-select v-model="loanAudit.hknl_value2" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in hknl_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">抵押物价值：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="hknl_value3">
                                            <el-select v-model="loanAudit.hknl_value3" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in hknl_list3"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="3">
                                        <div class="bankAuditLB">担保人信用及能力：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="dbcs_value1">
                                            <el-select v-model="loanAudit.dbcs_value1" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in dbcs_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">担保方式及风险:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="dbcs_value2">
                                            <el-select disabled v-model="loanAudit.dbcs_value2" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in dbcs_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7"></el-col>
                                <el-col :span="10">
                                <div class="bankAuditInfoTable">
                                    <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr style="font-weight: bold;">
                        <td colspan="2">信用状况</td>
                        <td colspan="2">还款能力</td>
                        <td colspan="2">担保措施</td>
                        <td colspan="2">额外分：</td>
                        <td colspan="2">最终得分</td>
                        <td colspan="2">预授信(万元）</td>
                        </tr>
                        <tr style="font-weight: bold;">
                        <td colspan="2">{{ scorelist[0] }}</td>
                        <td colspan="2">{{ scorelist[1] }}</td>
                        <td colspan="2">{{ scorelist[2] }}</td>
                        <td colspan="2">{{ scorelist[3] }}</td>
                        <td colspan="2">{{ scorelist[4] }}</td>
                        <td colspan="2">{{ scorelist[5] }}</td>
                        </tr>
                      </table> 
                                </div>
                            </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        资产评价
                                    </div>
                                </el-col>
                            </el-row>
                             <el-row>
                                     <el-col :span="3">
                                        <div class="bankAuditLB">土地流转信息（亩）：</div>
                                    </el-col>
                                    <el-col :span="9">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                v-model="loanCreditArea.area"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="bankAuditTitle">
                    <div class="bankAuditSplit"></div>
                    信用报告
                  </div>
                </el-col>
              </el-row>
              <template v-if="zxbglist.length>0">
                                    <template v-for="(item,index) in zxbglist" :key="item.Id">
                                            <el-row>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">贷款银行：</div>
                                                </el-col>
                                                <el-col :span="3">
                                                  <div class="bankAuditContent"> 
                                                    <el-select v-model="item.name" size="small" placeholder="请选择">
                                                        <el-option :label="bank.BankName" :value="bank.BankName" :key="bank.BankID" v-for="bank in bankList"></el-option>
                                                        <el-option label="其他" value="其他"></el-option>
                                                      </el-select>
                                                      </div>
                                                </el-col>
                                                <el-col :span="4" v-if="item.name=='其他'">
                                                    <div class="bankAuditContent"> 
                                                        <el-input
                                                            v-model="item.name2"
                                                            size="small"
                                                            placeholder="请输入贷款银行">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">贷款余额（万元）：</div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditContent"> 
                                                        <el-input
                                                            v-model="item.money"
                                                            size="small"
                                                            placeholder="请输入贷款金额">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">担保方式：</div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditContent"> 
                                                      <el-select v-model="item.bzfs" size="small" placeholder="请选择">
                                                          <el-option label="信用/无担保" value="信用/无担保"></el-option>
                                                          <el-option label="保证" value="保证"></el-option>
                                                          <el-option label="抵押" value="抵押"></el-option>
                                                          <el-option label="组合" value="组合"></el-option>
                                                      </el-select>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">是否逾期：</div>
                                                </el-col>
                                                <el-col :span="1">
                                                    <div class="bankAuditContent">
                                                        <el-select v-model="item.islate" size="small" placeholder="请选择">
                                                          <el-option label="是" value="1"></el-option>
                                                          <el-option label="否" value="0"></el-option>
                                                      </el-select>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2" v-if="item.islate=='1'">
                                                    <div class="bankAuditLB">逾期期限：</div>
                                                </el-col>
                                                <el-col :span="2" v-if="item.islate=='1'">
                                                    <div class="bankAuditContent"> 
                                                        <el-input
                                                            v-model="item.month"
                                                            size="small"
                                                            placeholder="请输入逾期期限">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="1" v-if="item.islate=='1'">
                                                    <div class="bankAuditLB">金额：</div>
                                                </el-col>
                                                <el-col :span="2" v-if="item.islate=='1'">
                                                    <div class="bankAuditContent"> 
                                                        <el-input
                                                            v-model="item.lateMoney"
                                                            size="small"
                                                            placeholder="请输入逾期金额">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="1">
                                                    <span class="removeTypeItem" @click="onRemoveZxbgChange(index)">×</span>
                                                </el-col>
                                                
                                            </el-row>
                                    </template>
                                
                                </template>
                                <el-row>
                                    <el-button style="margin:8px auto;" class="button-new-tag" size="small" @click="showZxbgInput">+ 新增</el-button>
                                </el-row>
                                <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        政务信息
                                    </div>
                                </el-col>
                            </el-row>
                             <el-row>
                                     <el-col :span="2">
                                        <div class="bankAuditLB">婚姻信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-select v-model="loanCreditArea.HYXX" size="small" placeholder="请选择">
                                                          <el-option label="未婚" value="未婚"></el-option>
                                                          <el-option label="已婚" value="已婚"></el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">户籍信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                v-model="loanCreditArea.HJXX"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">社保信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent">
                                            <el-select v-model="loanCreditArea.SBXX" size="small" placeholder="请选择">
                                                          <el-option label="单位参保" value="单位参保"></el-option>
                                                          <el-option label="个人参保" value="个人参保"></el-option>
                                                          <el-option label="暂停参保" value="暂停参保"></el-option>
                                                          <el-option label="尚未参保" value="尚未参保"></el-option>
                                                        </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">公积金信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-select v-model="loanCreditArea.GJJXX" size="small" placeholder="请选择">
                                                          <el-option label="正常缴存" value="正常缴存"></el-option>
                                                          <el-option label="封存" value="封存"></el-option>
                                                          <el-option label="销户" value="销户"></el-option>
                                                          <el-option label="尚未参保" value="尚未参保"></el-option>
                                                        </el-select>
                                        </div>
                                    </el-col>
                                </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="bankAuditTitle">
                    <div class="bankAuditSplit"></div>
                    村镇干部评价
                  </div>
                </el-col>
              </el-row>
              <el-row>
                                <el-col :span="2">
                                        <div class="bankAuditLB" >积分制积分：</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                v-model="loanCredit.comment2_jfzjf"
                                                size="small"
                                                placeholder="请输入积分制积分">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB" >规模：</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                v-model="loanCredit.comment2_gm"
                                                size="small"
                                                placeholder="请输入规模">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">技术：</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                v-model="loanCredit.comment2_js"
                                                size="small"
                                                placeholder="请输入技术">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB" >效益：</div>
                                    </el-col>
                                    <el-col :span="10">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                v-model="loanCredit.comment2_xy"
                                                size="small"
                                                placeholder="请输入效益">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">综合信誉：</div>
                                    </el-col>
                                    <el-col :span="10">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                v-model="loanCredit.comment2"
                                                size="small"
                                                placeholder="请输入综合信誉">
                                            </el-input>
                                        </div>
                                    </el-col>
                            </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="bankAuditTitle">
                    <div class="bankAuditSplit"></div>
                    同行评价
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2">
                  <div class="bankAuditLB" >规模：</div>
                </el-col>
                <el-col :span="10">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanCredit.comment_gm"
                      size="small"
                      placeholder="请输入规模">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="bankAuditLB">技术：</div>
                </el-col>
                <el-col :span="10">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanCredit.comment_js"
                      size="small"
                      placeholder="请输入技术">
                    </el-input>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2">
                  <div class="bankAuditLB" >效益：</div>
                </el-col>
                <el-col :span="10">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanCredit.comment_xy"
                      size="small"
                      placeholder="请输入效益">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="bankAuditLB">综合信誉：</div>
                </el-col>
                <el-col :span="10">
                  <div class="bankAuditContent">
                    <el-input
                      v-model="loanCredit.comment"
                      size="small"
                      placeholder="请输入综合信誉">
                    </el-input>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="bankAuditTitle">
                    <div class="bankAuditSplit"></div>
                    合同号信息
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2">
                  <div class="bankAuditLB" >委托担保合同号：</div>
                </el-col>
                <el-col :span="10">
                  <div class="bankAuditContent">
                    <el-form-item prop="WTDBHTH">
                      <el-input
                        v-model="loanAudit.WTDBHTH"
                        size="small"
                        placeholder="请输入合同号">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="bankAuditLB" style="width:150px">银行担保合同号：</div>
                </el-col>
                <el-col :span="10">
                  <div class="bankAuditContent">
                    <el-form-item prop="YHDBHTH">
                      <el-input
                        v-model="loanAudit.YHDBHTH"
                        size="small"
                        placeholder="请输入合同号">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="bankAuditTitle">
                    <div class="bankAuditSplit"></div>
                    附件信息
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-upload
                    accept=".doc,.docx,.xlsx,.xls,.pdf"
                    class="avatar-uploader"
                    :before-remove="handleFileRemove_FJ"
                    :before-upload="beforeAvatarFileUpload"
                    :http-request="uploadFileFile_FJ"
                    :file-list="fileList_FJ">
                    <i class="el-icon-collection avatar-uploader-icon">附件</i>
                  </el-upload>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="bankAuditTitle">
                    <div class="bankAuditSplit"></div>
                    修改内容
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" v-if="addType=='change'">
                  <div class="bankAuditLB" style="width:150px">退回内容：</div>
                </el-col>
                <el-col :span="20" v-if="addType=='change'">
                  <el-input
                    disabled
                    v-model="BackReason"
                    size="small"
                    style="margin-top: 15px;"
                    placeholder="">
                  </el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">
                  <div class="bankAuditLB" style="width:150px">补录修改内容：</div>
                </el-col>
                <el-col :span="20">
                  <el-input
                    v-model="modifyContent"
                    size="small"
                    style="margin-top: 15px;"
                    placeholder="请输入补录修改内容">
                  </el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="bankAuditOperate">
                    <el-button size="small" type="primary" @click="onSubmitModify"  v-if="addType=='change'">重新提交</el-button>
                    <el-button size="small" type="primary" @click="onSubmitModify"  v-else>提交审核</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>

    </div>
  </div>
</template>

<script>
    import {dateUtils} from "../../../utils/dateUtils";
    import apis from "../../../api";
    import flowapis from "../../../api/flow";
    import {utils} from "../../../utils/utils";
    import bankapis  from "../../../api/bank";
    import modifyFlowApi from "../../../api/modifyFlow";

    export default {
        name: "modifyFlowAudit",
        props: {
            flowId: {
                type: Number,
                require: true
            },
            closeCallback: {
                type: Function,
                require: true
            },
            submitCallback: {
                type: Function,
                require: true
            },
            addType: {
                type: String,
                require: true
            }
        },
        mounted() {
            let that = this;
            that.calcTableHeight();
            // 注：window.onresize只能在项目内触发1次
            window.onresize = function windowResize () {
                that.calcTableHeight();
            }
            // 去获取信息
            flowapis.getFlowById({Id: this.flowId}).then(res=>{
                this.queryData(res)
            })
            this.getBankList();
        },
        data() {
            return {
                modifyContent:'',
                activeName:'first',
                activeNameZx:'first',
                scrollHeight:400,
                query: {
                    userName: "",
                },
                isVisible:this.visible,
                llListResult:[],
                llShow:false,
                cllShow:false,
                llquery:false,
                credit:{num:"暂无",comment:"暂无"},
                flowInfo:{},
                fileList:[],
                fileList_FJ:[],
                picList:[],
                reasonVisible:false,
                queryTime:dateUtils.dateToStr("yyyy-MM-dd hh:mm:00",new Date()),
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,
                businessShow:false,
                 xmlist:['肉牛','柑桔','粮食','蔬菜','牲猪','水产','羊','鸡','砂梨','农业服务','农业旅游','苗木','园林绿化工程','农家乐','农资','秸秆回收','青储','饲料','其他'],
                firstBusinessOption:['电商','种植','养殖','农产品加工','农资农机销售','农产品购销','农业服务','农业旅游农家乐','农业相关工程','其他'],
                secondBusinessTitle: '二级分类',
                secondBusinessPlaceHolder: '输入对应主营项目的二级类目',

                loanApply:{
                    ApplyID:'',
                    UserId:'',
                    Phone:'',
                    PersonCompanyText:'',
                    PersonCompanyFlag:'',
                    PersonCompanyKey:'',
                    LoanTipsId:'',
                    Money:'',
                    CreateTime:'',
                    BankID:'',
                    BankSiteID:'',
                    SiteDirectorID:'',
                    FirstBusiness:'',
                    SecondBusiness:'',
                    PeopleCount:'',
                    LastYearIncome:'',
                    LastYearTax:'',
                    LastYearProfit:'',
                },
                loanAudit:{
                    Id:null,
                    Business:null,
                    BusinessDetail:null,
                    ThirdBusiness:[],
                    RiskSharing:null,
                    LoanCode:null,
                    LoanRate:null,
                    State:null,
                    LoanMonth:null,
                    FristInquirer:null,
                    SecondInquirer:null,
                    Category:null,
                    CreditRating:null,
                    TotalAssets:null,
                    SaleProceeds:null,
                    NetProfits:null,
                    Ratal:null,
                    LoanBalance:null,
                    GuaranteeType:3,
                    Guarantor:null,
                    GuarantorCode:null,
                    CustomProperty:null,
                    CustomType:null,
                    ReturnMoneyStatus:null,
                    GuaranteeLetterTime:null,
                    LoanEndTime:null,
                    LoanMoney:null,
                    EntrustedGuarantee:null,
                    AccountManager:null,
                    AccountManagerPhone:null,
                    ProTypeName:null,
                    Area:null,
                    GuaranteeRate:null,
                    PeopleCountAudit:'',
                    LastYearIncomeAudit:'',
                    LastYearTaxAudit:'',
                    LastYearProfitAudit:'',
                    WTDBHTH:'',
                    YHDBHTH:'',
                xyzk_value5:null,
                xyzk_value4:null,
                xyzk_value3:null,
                xyzk_value2:null,
                xyzk_value1:null,
                hknl_value1:null,
                hknl_value2:null,
                dbcs_value1:null,
                dbcs_value2:1,
                hknl_value3:null,
                },
                scorelist:[0,0,0,0,0,0],
                zxbglist:[],
                loanMortgage:[],
                loanCredit:{
                    Id:null,
                    keyword:null,
                    num:null,
                    createTime:null,
                    danwei:null,
                    money:null,
                    comment2:null,
                    comment2_gm:null,
                    comment2_xy:null,
                    comment2_js:null,
                    comment:null,
                    comment_xy:null,
                    comment_gm:null,
                    comment_js:null
                },
                loanCreditArea:{
                    Id:null,
                    keyword:null,
                    name:null,
                    area:null,
                },
                khlx:[
                    {
                        value:"家庭农场",
                        label:"家庭农场"
                    },
                    {
                        value:"合作社",
                        label:"合作社"
                    },
                    {
                        value:"公司",
                        label:"公司"
                    },
                    {
                        value:"种养大户",
                        label:"种养大户"
                    },
                    {
                        value:"个体户",
                        label:"个体户"
                    }
                ],
                wjfx:[
                    {
                        value:"正常贷款",
                        label:"正常贷款"
                    },
                    {
                        value:"关注贷款",
                        label:"关注贷款"
                    },
                    {
                        value:"次级贷款",
                        label:"次级贷款"
                    },
                    {
                        value:"可疑贷款",
                        label:"可疑贷款"
                    },
                    {
                        value:"损失贷款",
                        label:"损失贷款"
                    }
                ],
                khxz:[
                    {
                        value:"新增",
                        label:"新增"
                    },
                    {
                        value:"续贷",
                        label:"续贷"
                    },
                    {
                        value:"展期",
                        label:"展期"
                    }
                ],
                hkzt:[
                    {
                        value:1,
                        label:"结清"
                    },
                    {
                        value:2,
                        label:"逾期"
                    },
                    {
                        value:3,
                        label:"代偿"
                    }
                ],
                xyzk_list1:[{value:1,label:"无任何逾期"},
          {value:2, label:"轻微逾期，已结清"},
          {value:3, label:"多次逾期，无严重违约"},
          {value:4,label:"严重逾期或当前逾期"},
          {value:0,label:"无数据"},
        ],
        xyzk_list2:[{value:1,label:"近半年征信查询小于5次"},
          {value:2, label:"近半年征信贷款查询5-10次"},
          {value:3, label:"近半年征信贷款查询10次以上"},
          {value:0,label:"无数据"},
        ],
        xyzk_list3:[{value:1,label:"无诉讼记录"},
          {value:2, label:"已结案小额诉讼"},
          {value:3, label:"多未结案或大额诉讼"},
          {value:4,label:"频繁涉及诉讼"},
          {value:0,label:"无数据"},
        ],
        xyzk_list4:[{value:1,label:"已婚本地有房"},
          {value:2, label:"未婚本地有房"},
          {value:3, label:"已婚本地无房"},
          {value:4,label:"未婚本地无房"},
          {value:0,label:"无数据"},
        ],
        xyzk_list5:[{value:1,label:"经营稳定，盈利良好"},
          {value:2, label:"经营一般，盈利波动"},
          {value:3, label:"经营困难，当年亏损"},
          {value:4,label:"经营困难，连续亏损"},
          {value:0,label:"无数据"},
        ],
        hknl_list1:[{value:1,label:"资产负债率低"},
        {value:2, label:"资产负债率适中"},
        {value:3, label:"资产负债率偏高"},
        {value:4,label:"资产负债率过高"},
        {value:0,label:"无数据"},
        ],
        hknl_list2:[{value:1,label:"收入稳定，现金流充足"},
        {value:2, label:"收入一般，现金流尚可"},
        {value:3, label:"收入波动，现金流紧张"},
        {value:0,label:"无数据"},
        ],
        hknl_list3:[{value:1,label:"便于流通变现价值高于贷款金额"},
        {value:2, label:"便于流通变现价值低于贷款金额"},
        {value:3, label:"不便于流通变现"},
        {value:4, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:5, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:0,label:"无数据"},
        ],
        dbcs_list1:[{value:1,label:"信用优秀，担保能力强"},
        {value:2, label:"信用良好，担保能力适中"},
        {value:3, label:"信用一般，担保能力较弱"},
        {value:4,label:"信用较差，担保能力有限"},
        {value:5,label:"非有效担保人"},
        {value:0,label:"无数据"},
        ],
        dbcs_list2:[{value:1,label:"正式抵押+保证人"},
        {value:2, label:"正式抵押"},
        {value:3, label:"保证人"},
        {value:4, label:"无保证人或抵押物"},
        {value:0,label:"无数据"},
        ],
                dialogVisible2:false,
                dyType:'',
                dyTypes:[],
                dyTypes2:[
                    {
                        value:-1,
                        label:"保证人"
                    }
                ],
                dyTypes3:[
                    {
                        value:-1,
                        label:"保证人"
                    },
                    {
                        value:0,
                        label:"不动产"
                    },
                    {
                        value:1,
                        label:"设备"
                    },
                    {
                        value:2,
                        label:"水域滩涂"
                    },
                    {
                        value:3,
                        label:"农村承包土地"
                    },
                    {
                        value:4,
                        label:"股权"
                    },
                    {
                        value:5,
                        label:"其他"
                    }
                ],
                dyTypes4:[
                    {
                        value:0,
                        label:"不动产"
                    },
                    {
                        value:1,
                        label:"设备"
                    },
                    {
                        value:2,
                        label:"水域滩涂"
                    },
                    {
                        value:3,
                        label:"农村承包土地"
                    },
                    {
                        value:4,
                        label:"股权"
                    },
                    {
                        value:5,
                        label:"其他"
                    }
                ],
                proTypeList:[],
                bankInfoObj:{},
                areaList:[],
                myInterval:null,
                rules_loanAudit: {
                    Area:[
                        { required: true, message: '请选择区域', trigger: 'change' }
                    ],
                    CustomType:[
                        { required: true, message: '请选择客户类型', trigger: 'change' }
                    ],
                    CustomProperty:[
                        { required: true, message: '请选择客户性质', trigger: 'change' }
                    ],
                    ProTypeName:[
                        { required: true, message: '请选择项目类别', trigger: 'change' }
                    ],
                    RiskSharing:[
                        { required: true, message: '请填写项目风险比例(%)', trigger: 'change' }
                    ],
                    LoanMonth:[
                        { required: true, message: '请填写担保期限(月)', trigger: 'change' }
                    ],
                    LoanEndTime:[
                        { required: true, message: '请选择到期时间', trigger: 'change' }
                    ],
                    LoanCode:[
                        { required: true, message: '请填写贷款合同号', trigger: 'change' }
                    ],
                    GuaranteeRate:[
                        { required: true, message: '请填写担保费率(%)', trigger: 'change' }
                    ],
                    LoanMoney:[
                        { required: true, message: '请填写担保费(元)', trigger: 'change' }
                    ],
                    LoanRate:[
                        { required: true, message: '请填写借款利率', trigger: 'change' }
                    ],
                    Category:[
                        { required: true, message: '请选择五级分类', trigger: 'change' }
                    ],
                    FristInquirer:[
                        { required: true, message: '请填写主调', trigger: 'change' }
                    ],
                    SecondInquirer:[
                        { required: true, message: '请填写副调', trigger: 'change' }
                    ],
                    WTDBHTH:[
                        { required: true, message: '请填写副调', trigger: 'change' }
                    ],
                    YHDBHTH:[
                        { required: true, message: '请填写副调', trigger: 'change' }
                    ],
                },
                rules_loanApply:{
                    Money:[
                        { required: true, message: '请填写贷款金额(万元)', trigger: 'change' }
                    ],

                },
                BackReason:"",
                bankList:[],
            }
        },
        methods: {
          getBankList(){
        let param= {
          keyword: "",
          pageIndex: 0,
          pageSize: 0
         };
        bankapis.getBankList(param).then(res => {
         this.bankList=res.list
         })
      },
          onGetScore(){
        var data=this.loanAudit;
        var list=[
          [0,100,90,60,0],
          [0,100,70,0],
          [0,100,90,60,40],
          [0,100,80,70,0],
          [0,100,80,70,20],
          [0,100,90,80,60],
          [0,100,80,30],
          [0,100,90,70,60,40],
          [0,100,90,60,30,10],
          [0,100,80,70,0],
        ]
        var qzlist=[10,5,10,5,10,10,5,10,15,20];
        var datalist=[0,0,0,0,0,0,0,0,0,0];
        datalist[0]=data.xyzk_value1?data.xyzk_value1:0;
        datalist[1]=data.xyzk_value2?data.xyzk_value2:0;
        datalist[2]=data.xyzk_value3?data.xyzk_value3:0;
        datalist[3]=data.xyzk_value4?data.xyzk_value4:0;
        datalist[4]=data.xyzk_value5?data.xyzk_value5:0;
        datalist[5]=data.hknl_value1?data.hknl_value1:0;
        datalist[6]=data.hknl_value2?data.hknl_value2:0;
        datalist[7]=data.hknl_value3?data.hknl_value3:0;
        datalist[8]=data.dbcs_value1?data.dbcs_value1:0;
        datalist[9]=data.dbcs_value2?data.dbcs_value2:0;
        var scorelist=[0,0,0,0,0,0];
        scorelist[0]=list[0][datalist[0]]*qzlist[0]+list[1][datalist[1]]*qzlist[1]+
        list[2][datalist[2]]*qzlist[2]+list[3][datalist[3]]*qzlist[3]+list[4][datalist[4]]*qzlist[4];
        scorelist[1]=list[5][datalist[5]]*qzlist[5]+list[6][datalist[6]]*qzlist[6]+list[7][datalist[7]]*qzlist[7]
        scorelist[2]=list[8][datalist[8]]*qzlist[8]+list[9][datalist[9]]*qzlist[9]
        if(data.LastYearTax>100)scorelist[3]+=500;
        scorelist[4]=scorelist[0]+scorelist[1]+scorelist[2]+scorelist[3]
        for(var i=0;i<5;i++){
          scorelist[i]=scorelist[i]*0.01;
        }
       if(data.AssetCoverage!=""&&data.TotalAssets!=""){
            var value=Number(data.TotalAssets)*
            (65-Number(data.AssetCoverage))*scorelist[4]*0.0001;
            if(value>0){
              var max=100;
              if(data.CustomType=="家庭农场")max=200;
              else if(data.CustomType=="合作社"||data.CustomType=="公司")max=500;
              value=value>max?max:value;
              scorelist[5]=value.toFixed(2);
            }
        }
        this.scorelist=scorelist;
        
      },
      showZxbgInput(){
        var item={
          name:"",money:"",bzfs:"",islate:"",month:"",
        }
        this.zxbglist.push(item)
      },
      onRemoveZxbgChange(index){
        this.zxbglist.splice(index, 1)
      },
            onSubmitModify() {
                let that = this

                var zblist=this.zxbglist;
                for(var i=0;i<zblist.length;i++){
               if(zblist[i].name==""||zblist[i].money==""||
               zblist[i].islate==""||zblist[i].bzfs==""){
          this.$message({
            message: '请检查信用报告',
            type: 'warning'
          });
          return
          }
        if(zblist[i].name=="其他")zblist[i].name=zblist[i].name2
        }
        
          if(this.loanAudit.ThirdBusiness.length==0){
      this.$message.error("请您选择二级业务")
      return
  }
  if(this.businessShow&&this.loanAudit.BusinessDetail==null){
      this.$message.error("请您输入业务说明")
      return
  }
  if(this.modifyContent == '') {
                    that.$message.error("请输入补录修改内容")
                    return
                }
                that.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        if(that.loanAudit.ProTypeName&&that.loanAudit.LoanMonth&&(that.loanAudit.LoanMoney===0||that.loanAudit.LoanMoney)){
                            let loanAuditPara = utils.deepCopy(that.loanAudit);
                          loanAuditPara.scoreList=that.scorelist.join(",");
                          loanAuditPara.zxbgList=JSON.stringify(zblist);
                            if(that.loanAudit.GuaranteeLetterTime && JSON.stringify(that.loanAudit.GuaranteeLetterTime) !== '{}'){
                                if(!isNaN(Date.parse(that.loanAudit.GuaranteeLetterTime))){
                                    that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                                }
                                loanAuditPara.GuaranteeLetterTime = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",that.loanAudit.GuaranteeLetterTime)
                            }else{
                                loanAuditPara.GuaranteeLetterTime = null;
                            }

                            if(that.loanAudit.LoanEndTime && JSON.stringify(that.loanAudit.LoanEndTime) !== '{}'){
                                if(!isNaN(Date.parse(that.loanAudit.LoanEndTime))){
                                    that.loanAudit.LoanEndTime = new Date(that.loanAudit.LoanEndTime)
                                }
                                loanAuditPara.LoanEndTime = dateUtils.dateToStr("yyyy-MM-dd 00:00:00",that.loanAudit.LoanEndTime)
                            }else{
                                loanAuditPara.LoanEndTime = null;
                            }

                            if(loanAuditPara.LoanMoney){
                                loanAuditPara.LoanMoney = loanAuditPara.LoanMoney*100
                            }

                            that.loanCredit.keyword = that.loanApply.PersonCompanyKey
                            that.loanCredit.num= that.loanApply.Money
                            that.loanCredit.danwei= that.loanApply.PersonCompanyText

                            that.loanCreditArea.keyword = that.flowInfo.IdCard
                            that.loanCreditArea.name = that.flowInfo.Name
                            var loanMortgage=that.loanMortgage;
                            if(loanAuditPara.GuaranteeType==2){
                                if(loanMortgage.length>0){
                                    for(var i=loanMortgage.length-1;i>=0;i--){
                                        if(loanMortgage[i].Type!=-1){
                                            loanMortgage.splice(i,1)
                                        }
                                    }
                                }
                            }
                            else if(loanAuditPara.GuaranteeType==4){
                                if(loanMortgage.length>0){
                                    for(var i=loanMortgage.length-1;i>=0;i--){
                                        if(loanMortgage[i].Type==-1){
                                            loanMortgage.splice(i,1)
                                        }
                                    }
                                }
                            }



                            if(!this.businessShow) loanAuditPara.BusinessDetail="";
              loanAuditPara.ThirdBusiness=loanAuditPara.ThirdBusiness.join(",")
                            let param = {
                                loanAudit:that.setObjEmptyToNull(loanAuditPara),
                                loanMortgage:that.loanMortgage,
                                loanCredit:that.setObjEmptyToNull(that.loanCredit),
                                fileListFJ: that.fileList_FJ,
                                flowId: that.flowId,
                                addType: that.addType,
                                modifyContent: that.modifyContent,
                                loanCreditArea:that.setObjEmptyToNull(that.loanCreditArea)
                            }
                            // if(that.loanApply.Money){
                            //   param.flowInfo.FinalMoney = that.loanApply.Money*1000000
                            // }

                            modifyFlowApi.addModifyFlow(param).then((res) => {
                                if(res){
                                    that.submitCallback.call()
                                } else {
                                    that.$message.error("提交申请失败")
                                }
                            })
                        }
                    } else {
                        that.$message.error("请输入红框必填内容")
                        return false;
                    }
                });
            },
            setObjEmptyToNull(obj){
                Object.keys(obj).forEach(function(key, index) {
                    if (this[key] === '') this[key] = null;
                }, obj);
                return obj
            },
            queryData(row){
               if(this.addType=="view")this. queryData2(row)
               if(this.addType=="change")this. queryData3(row)
            },
            queryData2(row){
                let that = this
                this.scorelist=[0,0,0,0,0,0]
                 this.zxbglist=[]
                if(row){
                    that.flowInfo = utils.deepCopy(row)
                    // 查询审核信息
                    const shxx = flowapis.getLoanAuditInfo({
                        applyId:that.flowInfo.ApplyID,
                        auditId:that.flowInfo.AuditID,
                        IdCard:that.flowInfo.IdCard
                      }
                    )

                    const fileInfo = flowapis.getLoanFiles({processId:that.flowInfo.Id,type:'2',uploadType:'2'})

                    // // 查询政务信息
                    // const promise3 =

                    Promise.all([shxx,fileInfo]).then((res) => {
                        if(res.length===2){
                            if(res[0]){
                                if(res[0].applyObj){
                                    that.loanApply = res[0].applyObj
                                    that.changeSecondBusinessShow(that.loanApply.FirstBusiness)
                                }else{
                                    that.setEmptyApply()
                                    that.changeSecondBusinessShow(that.loanApply.FirstBusiness)
                                }
                                if(res[0].areaList){
                                    that.areaList = res[0].areaList
                                }else{
                                    that.setEmptyApply()
                                }

                                if(res[0].auditObj){
                                    that.loanAudit = res[0].auditObj
                                    if(that.loanAudit.GuaranteeLetterTime){
                                        that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                                    }
                                    if(that.loanAudit.LoanEndTime){
                                        that.loanAudit.LoanEndTime= new Date(that.loanAudit.LoanEndTime)
                                    }
                                    if(that.loanAudit.scoreList){
                                    that.scorelist = that.loanAudit.scoreList.split(",")
                                    }
                                    if(that.loanAudit.zxbgList){
                                    that.zxbglist = JSON.parse(that.loanAudit.zxbgList)
                                    }
                                    if(that.loanAudit.ThirdBusiness){
                                     that.loanAudit.ThirdBusiness=that.loanAudit.ThirdBusiness.toString().split(",");
                                          }else{
                                        that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                                           that.loanAudit.Business=that.loanApply.FirstBusiness
                                   that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                                          }
                                       that.changeSecond()
                                }else{
                                    that.setEmptyAudit()
                                    that.loanAudit.LastYearIncomeAudit = that.loanApply.LastYearIncome;
                                    that.loanAudit.LastYearProfitAudit = that.loanApply.LastYearProfit;
                                    that.loanAudit.LastYearTaxAudit = that.loanApply.LastYearTax;
                                    that.loanAudit.PeopleCountAudit = that.loanApply.PeopleCount;
                                    that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                                    that.loanAudit.Business=that.loanApply.FirstBusiness
                                 that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                                  that.changeSecond()
                                }

                                if(res[0].mortgageObj){
                                    that.loanMortgage = res[0].mortgageObj
                                }else{
                                    that.loanMortgage = []
                                }

                                if(res[0].proTypeList){
                                    that.proTypeList = res[0].proTypeList
                                    if(that.loanAudit.GuaranteeRate){
                                        that.setDbInfo()
                                    }else{
                                        that.setDbInfo2()
                                    }
                                }else{
                                    that.proTypeList = []
                                }
                                if(res[0].bankInfoObj){
                                    that.bankInfoObj = res[0].bankInfoObj
                                }else{
                                    that.bankInfoObj = {}
                                }
                                if(res[0].loanCreditObj){
                                    that.loanCredit = res[0].loanCreditObj
                                }else{
                                    that.setEmptyCredit()
                                }

                                if(res[0].loanCreditAreaObj){
                                    that.loanCreditArea = res[0].loanCreditAreaObj
                                }else{
                                    that.setEmptyCreditArea()
                                }
                            }else{
                                that.setEmptyApply()
                                that.setEmptyAudit()
                                that.loanMortgage = []
                                that.setEmptyCredit()
                                that.setEmptyCreditArea()
                            }
                            if(res[1]&&res[1].length>0){
                                that.fileList_FJ = []
                                for(let f=0;f<res[1].length;f++){
                                    that.fileList_FJ.push({
                                        name:res[1][f]['Name'],
                                        url:res[1][f]['Url']
                                    })

                                }
                            }else{
                                that.fileList_FJ = []
                            }
                        }
                    })
                }
            },
            changeSecond(){
        var value=this.loanAudit.ThirdBusiness;
        for(var i=0;i<value.length;i++){
           if(value[i]=="其他"){
               this.businessShow=true;
               return
         }
         }
         this.businessShow=false;
       },
            queryData3(){
                let that = this
                this.scorelist=[0,0,0,0,0,0]
                this.zxbglist=[]
                // 查询审核信息
                modifyFlowApi.getModifyFlowAllInfo({id:that.flowId}).then(res=>{
                    this.loanAudit = res.modifyFlowObj
                    that.BackReason=res.modifyFlowObj.BackReason
                    let fileList = res.fileList
                    if(fileList&&fileList.length>0){
                        that.fileList_FJ = []
                        for(let f=0;f<fileList.length;f++){
                            that.fileList_FJ.push({
                                name:fileList[f]['Name'],
                                url:fileList[f]['Url']
                            })
                        }
                    }else{
                        that.fileList_FJ = []
                    }
                    let infoObj = res.infoObj
                    if(infoObj){
                        if(infoObj.applyObj){
                            that.loanApply = infoObj.applyObj
                            that.changeSecondBusinessShow(that.loanApply.FirstBusiness)
                        }else{
                            that.setEmptyApply()
                            that.changeSecondBusinessShow(that.loanApply.FirstBusiness)
                        }
                        if(infoObj.areaList){
                            that.areaList = infoObj.areaList
                        }else{
                            that.setEmptyApply()
                        }

                        if(infoObj.auditObj){
                            that.loanAudit = infoObj.auditObj
                            if(that.loanAudit.GuaranteeLetterTime){
                                that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                            }
                            if(that.loanAudit.LoanEndTime){
                                that.loanAudit.LoanEndTime= new Date(that.loanAudit.LoanEndTime)
                            }
                            if(that.loanAudit.scoreList){
                              that.scorelist = that.loanAudit.scoreList.split(",")
                              }
                              if(that.loanAudit.zxbgList){
                                that.zxbglist = JSON.parse(that.loanAudit.zxbgList)
                              }
                              if(that.loanAudit.ThirdBusiness){
                                     that.loanAudit.ThirdBusiness=that.loanAudit.ThirdBusiness.toString().split(",");
                                          }else{
                                        that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                                           that.loanAudit.Business=that.loanApply.FirstBusiness
                                   that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                                          }
                                       that.changeSecond()
                        }else{
                            that.setEmptyAudit()
                            that.loanAudit.LastYearIncomeAudit = that.loanApply.LastYearIncome;
                            that.loanAudit.LastYearProfitAudit = that.loanApply.LastYearProfit;
                            that.loanAudit.LastYearTaxAudit = that.loanApply.LastYearTax;
                            that.loanAudit.PeopleCountAudit = that.loanApply.PeopleCount;
                            that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                                    that.loanAudit.Business=that.loanApply.FirstBusiness
                                 that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                                  that.changeSecond()
                        }

                        if(infoObj.mortgageObj){
                            that.loanMortgage = infoObj.mortgageObj
                        }else{
                            that.loanMortgage = []
                        }

                        if(infoObj.proTypeList){
                            that.proTypeList = infoObj.proTypeList
                            if(that.loanAudit.GuaranteeRate){
                                that.setDbInfo()
                            }else{
                                that.setDbInfo2()
                            }
                        }else{
                            that.proTypeList = []
                        }
                        if(infoObj.bankInfoObj){
                            that.bankInfoObj = infoObj.bankInfoObj
                        }else{
                            that.bankInfoObj = {}
                        }
                        if(infoObj.loanCreditObj){
                            that.loanCredit = infoObj.loanCreditObj
                        }else{
                            that.setEmptyCredit()
                        }

                        if(infoObj.loanCreditAreaObj){
                            that.loanCreditArea = infoObj.loanCreditAreaObj
                        }else{
                            that.setEmptyCreditArea()
                        }
                    }else{
                        that.setEmptyApply()
                        that.setEmptyAudit()
                        that.loanMortgage = []
                        that.setEmptyCredit()
                        that.setEmptyCreditArea()
                    }
                })

            },
            onDbqxChange(){
                let that = this
                let now = new Date()
                let givenMonth = now.getMonth()
                let newMonth = givenMonth + parseInt(that.loanAudit.LoanMonth)
                now.setMonth(newMonth)
                that.loanAudit.LoanEndTime = now
                that.setDbInfo()
            },
            setDbInfo(){
                let that = this
                try{
                    that.loanAudit.LoanMoney = Math.floor((((that.loanApply.Money*10000)*((that.loanAudit.GuaranteeRate*1.0)/100.0)*parseInt(that.loanAudit.LoanMonth))/12) * 100) / 100
                    if(isNaN(that.loanAudit.LoanMoney)){
                        that.loanAudit.LoanMoney = ''
                    }
                }catch(e){
                    that.loanAudit.GuaranteeRate = ''
                    that.loanAudit.RiskSharing = null
                    that.loanAudit.LoanMoney = null
                }

            },
            setDbInfo2(){
                let that = this
                for(let i=0;i<that.proTypeList.length;i++){
                    if(that.proTypeList[i]["ProTypeName"]===that.loanAudit.ProTypeName){
                        that.loanAudit.GuaranteeRate = that.proTypeList[i]['GuaranteeRate']
                        that.loanAudit.RiskSharing = that.proTypeList[i]['RiskRate']
                        try{
                            that.loanAudit.LoanMoney = Math.floor((((that.loanApply.Money*10000)*((that.loanAudit.GuaranteeRate*1.0)/100.0)*parseInt(that.loanAudit.LoanMonth))/12) * 100) / 100
                            if(isNaN(that.loanAudit.LoanMoney)){
                                that.loanAudit.LoanMoney = ''
                            }
                        }catch(e){
                            that.loanAudit.GuaranteeRate = ''
                            that.loanAudit.RiskSharing = null
                            that.loanAudit.LoanMoney = null
                        }
                        break
                    }
                }
            },
            showInput(){
                switch(this.loanAudit.GuaranteeType){
                    case 2:
                        this.dyTypes = this.dyTypes2
                        break;
                    case 3:
                        this.dyTypes = this.dyTypes3
                        break;
                    case 4:
                        this.dyTypes = this.dyTypes4
                        break;
                }
                this.dialogVisible2 = true
            },
            handleClose(){
                this.dialogVisible2 = false
            },
            onAddItemChange(){
                let item= this.getEmptyMortgage()
                item.Type = this.dyType
                this.loanMortgage.push(item)
                this.dialogVisible2 = false
            },
            setEmptyApply(){
                let that = this
                that.loanApply = {
                    ApplyID:'',
                    UserId:'',
                    Phone:'',
                    PersonCompanyText:'',
                    PersonCompanyFlag:'',
                    PersonCompanyKey:'',
                    LoanTipsId:'',
                    Money:'',
                    CreateTime:'',
                    BankID:'',
                    BankSiteID:'',
                    SiteDirectorID:'',
                    FirstBusiness:'',
                    SecondBusiness:'',
                    PeopleCount:'',
                    LastYearIncome:'',
                    LastYearTax:'',
                    LastYearProfit:'',
                }
            },
            setEmptyAudit(){
                let that = this
                that.loanAudit = {
                    Id:null,
                    Business:null,
                    BusinessDetail:null,
                    RiskSharing:null,
                    LoanCode:null,
                    LoanRate:null,
                    State:null,
                    LoanMonth:null,
                    FristInquirer:null,
                    SecondInquirer:null,
                    Category:null,
                    CreditRating:null,
                    TotalAssets:null,
                    SaleProceeds:null,
                    NetProfits:null,
                    Ratal:null,
                    LoanBalance:null,
                    GuaranteeType:3,
                    Guarantor:null,
                    GuarantorCode:null,
                    CustomProperty:null,
                    CustomType:null,
                    ReturnMoneyStatus:null,
                    GuaranteeLetterTime:null,
                    LoanEndTime:null,
                    LoanMoney:null,
                    EntrustedGuarantee:null,
                    AccountManager:null,
                    AccountManagerPhone:null,
                    ProTypeName:null,
                    Area:null,
                    GuaranteeRate:null,
                    WTDBHTH:null,
                    YHDBHTH:null
                }
                this.scorelist=[0,0,0,0,0,0],
                this.zxbglist=[]
            },
            getEmptyMortgage(){
                let loanMortgagetemp = {
                    Id:null,
                    AuditID:null,
                    Guarantor:null,
                    GuarantorID:null,
                    BdcName:null,
                    BdcQzh:null,
                    BdcArea:null,
                    BdcMoney:null,
                    BdcDyqzh:null,
                    SbName:null,
                    SbCount:null,
                    SbType:null,
                    SbMoney:null,
                    SbDyqzh:null,
                    SytName:null,
                    SytQzh:null,
                    SytArea:null,
                    SytMoney:null,
                    SytDyqzh:null,
                    NccbtdName:null,
                    NccbtdQzh:null,
                    NccbtdArea:null,
                    NccbtdMoney:null,
                    NccbtdDyqzh:null,
                    GqName:null,
                    GqCount:null,
                    GqMoney:null,
                    GqDyzqh:null,
                    OtherName:null,
                    OtherCount:null,
                    OtherGg:null,
                    OtherMoney:null,
                    OtherDyqzh:null,
                    OtherBfwName:null,
                    OtherBfwGg:null,
                    OtherBfwMoney:null,
                    OtherBfwDyqzh:null,
                    Type:null
                }
                return loanMortgagetemp
            },
            setEmptyCredit(){
                let that = this
                that.loanCredit = {
                    Id:null,
                    keyword:null,
                    num:null,
                    createTime:null,
                    danwei:null,
                    money:null,
                    comment2:null,
                    comment2_gm:null,
                    comment2_xy:null,
                    comment2_js:null,
                    comment:null,
                    comment_xy:null,
                    comment_gm:null,
                    comment_js:null
                }
            },
            setEmptyCreditArea(){
                let that = this
                that.loanCreditArea = {
                    Id:null,
                    keyword:null,
                    name:null,
                    area:null,
                }
            },
            onRemoveTypeChange(index){
                this.loanMortgage.splice(index, 1)
            },
            loanTypeChange(){
              var type=Number(this.loanAudit.GuaranteeType);
        if(type==1)this.loanAudit.dbcs_value2=4;
        else if(type==2)this.loanAudit.dbcs_value2=3;
        else if(type==3)this.loanAudit.dbcs_value2=1;
        else if(type==4)this.loanAudit.dbcs_value2=2;
        this.onGetScore()
            },
            changeAssetCoverage(){
              if(this.loanAudit.AssetCoverage){
        var num=Number(this.loanAudit.AssetCoverage)
        if(num<30)this.loanAudit.hknl_value1=1;
        else if(num>=30&&num<40)this.loanAudit.hknl_value1=2;
        else if(num>=40&&num<50)this.loanAudit.hknl_value1=3;
        else if(num>=50)this.loanAudit.hknl_value1=4;
         }
        else {
           this.loanAudit.hknl_value1="";
        }
        this.changeHknl2();
        this.onGetScore()
      },
      changeHknl2(){
        if(!this.loanAudit.LastYearIncomeAudit)return
        if(!this.loanAudit.TotalAssets)return
        if(!this.loanAudit.AssetCoverage)return
        var num1=Number(this.loanAudit.LastYearIncomeAudit)
        var num2=Number(this.loanAudit.TotalAssets)
        var num3=Number(this.loanAudit.AssetCoverage)
        var num4=num2*num3/100;
        if(num1<=num4)this.loanAudit.hknl_value2=3;
        else if(num1>num4&&num1<num4*2)this.loanAudit.hknl_value2=2;
        else if(num1>=num4*2)this.loanAudit.hknl_value2=1;
        this.onGetScore()
      },
            proTypeChange(){
                let that = this
                that.setDbInfo2()
            },
            onDBFLChange(){
                let that = this
                that.setDbInfo()
            },
            beforeAvatarFileUpload(file) {
                let that = this
                const isLt2M = file.size/1024/1024 <10
                if(!isLt2M){
                    that.$message.error("上传文件大小不能超过10MB")
                }
                return true
            },
            uploadFileFile_FJ(item){
                let that = this
                let fileObj = item.file
                const form = new FormData()
                form.append("file",fileObj)
                apis.uploadFile(form).then(res => {
                    that.fileList_FJ.push({
                        name: that.getFileName(res.fullPath),
                        url:res.fullPath
                    })
                    // let fileInfo = {
                    //     ProcessId:that.flowInfo.Id,
                    //     Type:'2',
                    //     Url:res.fullPath,
                    //     Name:that.getFileName(res.fullPath),
                    //     UploadType:2
                    // }
                    // flowapis.addLoanFile({fileList:[fileInfo]}).then(res => {})
                });
            },
            getFileName(path){
                var pos1 = path.lastIndexOf('/');
                var pos2 = path.lastIndexOf('\\');
                var pos  = Math.max(pos1, pos2)
                if( pos<0 )
                    return path;
                else
                    return path.substring(pos+1);
            },
            handleFileRemove_FJ(file) {
                let that = this
                if(file){
                    for(let i=0;i<that.fileList_FJ.length;i++){
                        if(file.url===that.fileList_FJ[i].url){
                            that.fileList_FJ.splice(i,1)
                        }
                    }
                }
            },
            onFirstBusinessChooseConfirm(value){
                //变更二级分类的标题和placeholder
                this.changeSecondBusinessShow(value)
            },
            changeSecondBusinessShow(value) {
                switch (value) {
                    case '电商':
                        this.secondBusinessTitle = '销售类目'
                        this.secondBusinessPlaceHolder = '如：生鲜、粮油'
                        break;
                    case '种植':
                        this.secondBusinessTitle = '种植作物'
                        this.secondBusinessPlaceHolder = '如：水稻、棉花'
                        break;
                    case '养殖':
                        this.secondBusinessTitle = '养殖种类'
                        this.secondBusinessPlaceHolder = '如：猪、肉牛'
                        break;
                    case '农产品加工':
                        this.secondBusinessTitle = '加工品类'
                        this.secondBusinessPlaceHolder = '如：粮食加工、柑橘加工'
                        break;
                    case '农资农机销售':
                        this.secondBusinessTitle = '销售品类'
                        this.secondBusinessPlaceHolder = '如：播种机、拖拉机、农资销售'
                        break;
                    case '农产品购销':
                        this.secondBusinessTitle = '产品类型'
                        this.secondBusinessPlaceHolder = '如：柑橘、蔬菜'
                        break;
                    case '农业服务':
                        this.secondBusinessTitle = '服务项目'
                        this.secondBusinessPlaceHolder = '如：收割、无人机植保'
                        break;
                    case '农业旅游农家乐':
                        this.secondBusinessTitle = '产业类型'
                        this.secondBusinessPlaceHolder = '如：玫瑰园、果园、农家乐餐饮'
                        break;
                    case '农业相关工程':
                        this.secondBusinessTitle = '工程内容'
                        this.secondBusinessPlaceHolder = '如：大棚、土壤改良、绿化工程'
                        break;
                    case '其他':
                        this.secondBusinessTitle = '经营项目'
                        this.secondBusinessPlaceHolder = '请填经营项目'
                        break;
                }
            },
            closeContent() {
                this.closeCallback.call()
            },
            calcTableHeight(){
                this.$nextTick(() => {
                    let height1=$(".content-box .content").height();
                    let height=height1-50-20-40-20;
                    this.scrollHeight = height;
                });
            },
        }
    }
</script>

<style>
  @import url(./assets/style/style.less);
/*.modify-flow-audit-content{*/
/*  background-color: rgb(220, 234, 235)!important;*/
/*  height: calc(100% - 15px);*/
/*  font-size: 14px;*/
/*  position: absolute;*/
/*  width: calc(100% - 20px);*/
/*  top: 10px;*/
/*  overflow-x: hidden;*/
/*  overflow-y: auto;*/
/*  box-sizing: border-box;*/
/*}*/
/*.close-btn{*/
/*  right: 20px;*/
/*  top: 10px;*/
/*  position: absolute;*/
/*  font-size: 27px;*/
/*  cursor: pointer;*/
/*}*/
/*.content{*/
/*  position: absolute;*/
/*  left: 0;*/
/*  top: 0;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*}*/
</style>
